import React, {
	createContext,
	useContext,
	useState,
	useEffect,
	useCallback,
} from "react";
import axios from "axios";

const AuthContext = createContext();

export function useAuth() {
	return useContext(AuthContext);
}

export function AuthProvider({ children }) {
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	const logout = useCallback(() => {
		localStorage.removeItem("token");
		delete axios.defaults.headers.common["Authorization"];
		setUser(null);
	}, []);

	const fetchUserProfile = useCallback(async () => {
		try {
			const response = await axios.get("/api/users/perfil");
			setUser(response.data);
		} catch (error) {
			console.error("Error al obtener perfil:", error);
			logout();
		} finally {
			setLoading(false);
		}
	}, [logout]);

	useEffect(() => {
		const token = localStorage.getItem("token");
		if (token) {
			axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
			fetchUserProfile();
		} else {
			setLoading(false);
		}
	}, [fetchUserProfile]);

	const login = async (email, password) => {
		try {
			const response = await axios.post("/api/auth/login", {
				email,
				password,
			});

			const { token, user } = response.data;

			localStorage.setItem("token", token);
			axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
			setUser(user);

			return { success: true };
		} catch (error) {
			return {
				success: false,
				message: error.response?.data?.message || "Error al iniciar sesión",
			};
		}
	};

	const value = {
		user,
		login,
		logout,
		loading,
	};

	return (
		<AuthContext.Provider value={value}>
			{!loading && children}
		</AuthContext.Provider>
	);
}
